import React, { useState, useRef } from 'react';
import useOutsideClick from '../../../lib/useOutsideClick';
const TablePop = ({ children }) => {
    const [isVisible, setVisible] = useState(false);
    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, () => setVisible(false))
    return (<td ref={wrapperRef} className="table-pop">
        <span className="open-pop" onClick={() => setVisible(!isVisible)}>
            ...
        </span>
        <div className={`table-pop-box ${isVisible ? 'show' : ''}`}>
            {
                children
            }
        </div>
    </td>
    )
}
export default TablePop;